import React from 'react';
import { NavBar, Footer } from './shared.jsx';

/**
 * Shared editorial page layout.
 * Wraps any redesigned content inside <div className="pageA"> with
 * NavBar + Footer. Includes an optional hero (eyebrow / title / lead / CTAs)
 * and typography scopes its body under .articleA so legacy inline styles
 * inside children still work but CSS gives them a consistent editorial feel.
 */
export default function EditorialArticle({
  navPage,
  onNav,
  eyebrow,
  title,
  lead,
  meta,
  primaryCta,
  secondaryCta,
  children,
}) {
  return (
    <div className="pageA">
      <NavBar page={navPage} onNav={onNav} />
      <main>
        {(eyebrow || title || lead || primaryCta || secondaryCta) && (
          <section className="articleA-hero">
            {eyebrow && <span className="eyebrowA">{eyebrow}</span>}
            {title && <h1>{title}</h1>}
            {lead && <p className="articleA-lead">{lead}</p>}
            {meta && <div className="articleA-meta">{meta}</div>}
            {(primaryCta || secondaryCta) && (
              <div className="articleA-cta">
                {primaryCta}
                {secondaryCta}
              </div>
            )}
          </section>
        )}
        <article className="articleA">{children}</article>
      </main>
      <Footer onNav={onNav} />
    </div>
  );
}
